import variables from '../variables';

const MuiFormControl = {
  variants: [
    {
      props: { error: true },
      style: {
        '& > label': {
          color: variables.colors.darkRed,
        },
      },
    },
  ],
};

export default MuiFormControl;
